import { useState } from "react";
import DemoForm from "./DemoForm";
import "./EnquiryButton.css";

const EnquiryButton = () => {
    const [showDemoModal, setShowDemoModal] = useState(false);

    return (
        <>
            <button
                className="enquiry-btn"
                onClick={() => setShowDemoModal(true)}
            >
                For Enquiry
            </button>

            {showDemoModal && (
                <DemoForm onClose={() => setShowDemoModal(false)} />
            )}
        </>
    );
};

export default EnquiryButton;